
import { Component, Vue, Watch } from "vue-property-decorator";
import { UsersList as UL } from "@/graph/servicecloud/users";
import graph from "@/graph";
import ebiEditbar from "@/components/editbar/ebiEditbar.vue";
import UserEdit from "./UserEdit.vue";
import ebiActionsButtonBar from "@/components/actionsButtonBar/ebiActionsButtonBar.vue";
import { v4 as uuidv4 } from "uuid";
import { EventBus } from "@/events/event-bus";

@Component({
	components: {
		ebiEditbar,
		ebiActionsButtonBar,
		UserEdit,
	},
})
export default class UsersList extends Vue {

	loadingTable = true;
	usersList: UL[] = [];

  needReload = false;

	editbarTitle = "";
	showEditbar = false;
	showAddDialog = false;
	selectedUserId = "";
  shownSecret = "";
	addUserForm = {
		name: "",
		key: "",
		secret: "",
	};

  search = "";

	get filteredUsersList(): UL[]
	{
		return this.search ? this.usersList.filter((element) => {
			const s = this.search.toLowerCase();

			if(element.name.toLowerCase().indexOf(s) >= 0)
			{
				return true;
			}
			else if(element.key.toLowerCase().indexOf(s) >= 0)
			{
				return true;
			}
			else if(element.secret.toLowerCase().indexOf(s) >= 0)
			{
				return true;
			}
			return false;
		}) : this.usersList;
	}

	async createUser()
	{
		if(
			this.addUserForm.name.length <= 1 &&
			this.addUserForm.key.length <= 1 &&
			this.addUserForm.secret.length <= 1
		)
		{
			return;
		}


		try {

      const result = await graph.servicecloud.users.createUser(this.addUserForm.name, this.addUserForm.key, this.addUserForm.secret);

    } catch (error) {

      // ToDo: Prettyfy error message
      this.$notify.error(error.message);
      return;
    }

		await this.loadTable();
		
		this.showAddDialog = false;
	}

	handleEdit(index: number, row: UL)
	{
		console.log("UserList::handleEdit",index, row);

		this.editbarTitle = "Edit: " + row.name + " (" + row.id + ")";
		this.showEditbar = true;
		this.selectedUserId = row.id;

		console.log("UserList::handleEdit::END");
	}

  showSecret(row: UL) {
    this.shownSecret = row.id;
  }

	@Watch("showEditbar")
	onEditbarChange(current: boolean, old: boolean)
	{
		console.log("UserList::onEditbarChange", "current", current, "old", old);
		if(current === false && old === true)
		{
			this.selectedUserId = "";

     if(this.needReload) {
       this.needReload = false;
       this.loadTable();
		}
	 }
  }

  async handleDelete(index: number, row: UL)
	{
		console.log("UserList::handleDelete", index, row);

    const result = await graph.servicecloud.users.deleteUser(row.id);

    if (!result.success) {
      this.$notify.error('Error while deleting user');
      return;
    }

    this.loadTable();
	}

	generateUUID(name: string)
	{
		console.log("UsersList generateUUID", "name", name);

		if(name === "key")
		{
			if(this.addUserForm)
			{
				this.addUserForm.key = uuidv4();
			}
		}
		else if(name === "secret")
		{
			if(this.addUserForm)
			{
				this.addUserForm.secret = uuidv4();
			}
		}
	}

	async loadTable()
	{
		console.log("UsersList loadTable");

		this.loadingTable = true;
		this.reset();
		const result = await graph.servicecloud.users.list();
		this.usersList = result;
		this.loadingTable = false;
	}

  reset() {
    this.editbarTitle = "";
    this.usersList = [];
    this.showEditbar = false;
    this.showAddDialog = false;
    this.selectedUserId = "";
    this.addUserForm = {
      name: "",
      key: "",
      secret: "",
    };
  }

	mounted()
	{
		this.loadingTable = true;
		this.loadTable();

    EventBus.$on('environment-changed', () => {
      this.loadTable();
    });
	}
}
